import { useCallback, useMemo } from 'react';
import OperationalDashboardAccordion from "./operationalDashboardAccordion";

const DISCIPLINE_KEY_TO_READABLE = {
    company: 'Company',
    rcx: 'RCX',
    rotary: 'Rotary',
    surface_core: 'Surface Core',
    underground_core: ' Underground Core',
}

const OperationalDashboardAccordionsByDiscipline = ({disciplineData, disciplineKey}) => {
    const rigsData = disciplineData.summary_by_rigs;
    const hasRigData = !Array.isArray(rigsData);

    const shouldShowDiscipline = useMemo(() =>
        !Object
            .keys(disciplineData.summary)
            .every(key => disciplineData.summary[key] === null) && disciplineData.summary_by_rigs.length === 0, [disciplineData]);

    const shouldShowRig = useCallback(rigData => {
        if (Object.keys(rigData).every(key => rigData[key] === null)) {
            return false;
        }

        return true;
    }, []);

    return (
        <>
            {shouldShowDiscipline && <OperationalDashboardAccordion
                title={DISCIPLINE_KEY_TO_READABLE[disciplineKey]}
                data={disciplineData.summary}
            />}
            {
                hasRigData && Object.keys(rigsData).map((rig) => {
                    if (shouldShowRig(rigsData[rig])) {
                        return <OperationalDashboardAccordion
                            key={rig}
                            title={rig}
                            data={rigsData[rig]}
                        />
                    }

                    return null;
                })
            }
        </>
    );
}

export default OperationalDashboardAccordionsByDiscipline;